import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { formatDistributionCenterName } from '@/utils/formatters'
import { movementFor, type PoLevelDetailRow } from './poLevelDetailViewMockData'

interface Props {
  rows: PoLevelDetailRow[]
}

export function POLevelDetailViewTable({ rows }: Props) {
  const totalDollarsShifted = rows.reduce((sum, r) => sum + r.dollarsShifted, 0)
  const totalUnitsShifted = rows.reduce((sum, r) => sum + r.unitsShifted, 0)

  return (
    <div className="max-h-[640px] overflow-auto rounded-lg border border-border bg-white shadow-sm">
      <Table>
        <TableHeader className="sticky top-0 z-10 bg-white">
          <TableRow className="hover:bg-transparent">
            <TableHead>PO</TableHead>
            <TableHead>Division</TableHead>
            <TableHead>Department</TableHead>
            <TableHead>Class</TableHead>
            <TableHead>Subclass</TableHead>
            <TableHead>Container</TableHead>
            <TableHead>SKU</TableHead>
            <TableHead>DC</TableHead>
            <TableHead>Orig Arr Wk</TableHead>
            <TableHead>Estimated Arr Wk</TableHead>
            <TableHead className="text-right">Days Shifted</TableHead>
            <TableHead>Movement</TableHead>
            <TableHead className="text-right">Dollars Shifted</TableHead>
            <TableHead className="text-right">Units Shifted</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.po}>
              <TableCell>{row.po}</TableCell>
              <TableCell>{row.division}</TableCell>
              <TableCell>{row.department}</TableCell>
              <TableCell>{row.className}</TableCell>
              <TableCell>{row.subclass}</TableCell>
              <TableCell />
              <TableCell>{row.sku}</TableCell>
              <TableCell>{formatDistributionCenterName(row.dc)}</TableCell>
              <TableCell>{row.origArrWk}</TableCell>
              <TableCell>{row.estimatedArrWk}</TableCell>
              <TableCell className="text-right tabular-nums">
                {row.daysShifted}
              </TableCell>
              <TableCell>{movementFor(row)}</TableCell>
              <TableCell className="text-right tabular-nums">
                ${row.dollarsShifted.toLocaleString('en-US')}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.unitsShifted.toLocaleString('en-US')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell className="font-bold">Total</TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell className="text-right tabular-nums">0</TableCell>
            <TableCell />
            <TableCell className="text-right tabular-nums">
              ${totalDollarsShifted.toLocaleString('en-US')}
            </TableCell>
            <TableCell className="text-right tabular-nums">
              {totalUnitsShifted.toLocaleString('en-US')}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  )
}
